export default "__VITE_ASSET__Co2aVEy5__"